import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './promoBox.module.css'

import { config } from '../../../common/config'

interface IProps {
  title: string
  logo: string
  slim?: boolean
  content: string[]
}

const PromoBox: React.FC<IProps> = ({
  children,
  title,
  logo,
  content,
  slim
}) => {
  const style = classnames(styles.root, { [styles.slim]: slim })

  return (
    <div className={style}>
      <div className={styles.logoWrapper}>
        <img
          className={styles.logo}
          src={`${config.assets.PUBLIC_PATH}/${logo}`}
          alt={title}
        />
      </div>

      <div className={styles.contentWrapper}>
        <h5 className={styles.title}>{title}</h5>

        <ul className={styles.content}>
          {content.map((child, i) => {
            return (
              <li key={i} className={styles.listItem}>
                {child}
              </li>
            )
          })}
        </ul>

        {children}
      </div>
    </div>
  )
}

export default PromoBox
